<template lang="pug">
  .b-select
    ._label(v-if="labelOuter") {{ label }}
    ._inner.-with-arrow(@click="toggleDropdown" :class="{selected: value.length}")
      Icon._icon(v-if="icon" :name="icon")
      span._selected-value(v-if="value.length") {{ selectedItemText }}
      span._placeholder(v-else) {{ labelOuter ? notSelectedLabel : label }}
      ._cross-icon(v-if="!opened && value.length" @click="clearAll(true)")
        Icon(name="cross" pointer)
      slot
    ._dropdown(v-if="opened" :class="{ opened }" :style="{ top: verticalShift }")
      ._list(ref="list")
        ._scrollable
          .__selection-line
            slot(name="actions" :setValues="setValues")
              Btn(sm blue @click="selectAll") Выбрать все
              Btn(sm grey @click="clearAll") Очистить
          ._filter(v-if="useFilter")
            BaseInput(v-model="filter" iconName="search" label="Поиск")
          //._item(v-if="showNotSelectedItem" @click="selectOption(notSelectedValue)") {{ notSelectedLabel }}
          ._item(v-for="item in optionsFiltered" :key="item.value" @click="selectOption(item.value)")
            BaseCheckbox.__checkbox(:value="!!internalValue.find(val => val === item.value)" @input="selectOption(item.value)")
            | {{ item.label }}
        .__selection-applier
          Btn(@click="applySelection" stretch) Применить
</template>

<script>
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseInput from '@/components/BaseInput.vue';

export default {
  name: 'BaseSelectMulti',
  components: { BaseCheckbox, BaseInput },
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    notSelectedLabel: {
      type: String,
      default: 'Не выбрано',
    },
    notSelectedValue: {
      type: Array,
      default: () => [],
    },
    hideNotSelected: {
      type: Boolean,
      default: false,
    },
    label: String,
    labelOuter: Boolean,
    icon: String,
    pageSize: Boolean,
    useFilter: Boolean,
  },
  data() {
    return {
      opened: false,
      filter: '',
      verticalShift: '0',
      internalValue: [],
    };
  },
  watch: {
    value: {
      handler(value) {
        this.internalValue = value.slice();
      },
      immediate: true,
    },
    opened(val) {
      if (!val) {
        this.verticalShift = '0';
        return;
      }

      this.$nextTick(() => {
        const bottomOfWindow = window.innerHeight;
        const bottomOfDropdown = this.$refs.list.getBoundingClientRect().bottom;

        const shift = bottomOfWindow - bottomOfDropdown;
        this.verticalShift = shift < 0 ? `${shift}px` : '0';
      });
    },
  },
  computed: {
    selectedItemText() {
      const selectedItem = this.labelOuter ? 'Выбрано' : this.label;
      return `${selectedItem}: ${this.value.length}`;
    },
    showNotSelectedItem() {
      return !this.hideNotSelected && this.value !== this.notSelectedValue;
    },
    optionsCompiled() {
      if (!Array.isArray(this.options)) {
        return Object.entries(this.options).map(([value, label]) => ({ value, label }));
      }

      if (typeof this.options?.[0] !== 'object') {
        return this.options.map(v => ({ value: v, label: v }));
      }

      return this.options;
    },
    optionsFiltered() {
      const prep = s => s.toLowerCase().replace(/ /g, '');
      const filter = prep(this.filter);
      return this.optionsCompiled.filter(o => !filter || prep(o.label).includes(filter));
    },
  },
  methods: {
    selectOption(optionValue) {
      const findIndex = this.internalValue.findIndex(val => val === optionValue);
      if (findIndex !== -1) this.internalValue.splice(findIndex, 1);
      else this.internalValue.push(optionValue);
    },
    toggleDropdown() {
      this.opened = !this.opened;
    },
    setValues(values) {
      this.internalValue = values;
    },
    selectAll() {
      this.internalValue = this.optionsCompiled.map(o => o.value);
    },
    clearAll(apply = false) {
      this.internalValue = [];

      if (apply) {
        this.applySelection();
      }
    },
    applySelection() {
      this.$emit('input', this.internalValue);
      this.$emit('change', this.internalValue);
      this.opened = false;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.opened = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.close);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close);
  },
};
</script>

<style scoped lang="scss">

  .select {
    cursor: pointer;

    &__label {
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      letter-spacing: 0.01em;
      color: #92A0B0;
      margin-bottom: 8px;
    }

    &__inner {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      border: none;
      padding: 0 50px 0 16px;
      height: 38px;
      border-radius: 6px;
      font-size: 13px;
      font-weight: 500;
      color: var(--color-dark-gray);
      position: relative;

      &--with-arrow {
        background-image: url(../assets/img/svg/angle-down.svg);
        background-color: var(--color-super-light);
        background-size: 12px;
        background-position: top 16px right 15px;
        background-repeat: no-repeat;
      }

      &.selected {
        background: #49A7FD;
        color: var(--color-white);
      }
    }

    &__cross-icon {
      min-width: 12px;
      position: absolute;
      right: 14px;
      top: 14px;
      cursor: pointer;
      fill: var(--color-white);
    }

    &__placeholder {
      color: var(--color-middle-gray);
    }

    &__icon {
      margin-right: 11px;
    }
    &__dropdown {
      position: relative;
    }

    &__dropdown.opened &__list {
      visibility: visible;
    }

    &__list {
      box-sizing: border-box;
      padding: 8px 0;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
      margin-top: 4px;
      border: none;
      border-radius: 6px;
      position: absolute;

      will-change: visibility;
      visibility: hidden;
      z-index: 10;
      background-color: #ffffff;
      top: 100%;
    }

    &__scrollable {
      max-height: 320px;
      overflow: auto;
    }

    &__item {
      padding: 12px 0;
      margin: 0 20px;
      cursor: pointer;
      color: var(--color-middle-gray);
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;

      &:hover, &.selected {
        padding: 12px 20px;
        margin: 0;
      }

      &:hover + &, &.selected + & {
        border-top-color: transparent;
      }

      &.selected {
        background: #ECF1FF;
      }

      &:hover {
        background: #E1E7F8;
      }
    }
    &__item {
      &--selectable {
        display: flex;
        align-items: center;
        white-space: nowrap;
      }
    }

    &__checkbox {
      margin-right: 12px;
    }

    &__selection {
      &-line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 20px;
        padding: 10px 0 20px;
        box-sizing: border-box;
        min-width: 250px;
        border-bottom: 1px solid var(--color-purple);
      }

      &-applier {
        width: 100%;
        box-sizing: border-box;
        padding: 15px 20px;
        display: flex;
        justify-content: center;
      }
    }

    &__filter {
      padding: 20px 20px 20px;
    }
  }

</style>
